export default "__VITE_ASSET__59f1b1f4__"